import React, {FC, ReactNode} from "react";
import "./ui.css";

type PageHeaderProps = {
    title: ReactNode;
    kicker?: ReactNode;
    description?: ReactNode;
    actions?: ReactNode;
    // 1 for a top-level page; 2 inside the event workspace, whose header already holds the h1.
    level?: 1 | 2;
};

export const PageHeader: FC<PageHeaderProps> = ({title, kicker, description, actions, level = 1}) => {
    const Heading = level === 1 ? "h1" : "h2";

    return (
        <header className="ati-page-header">
            <div className="ati-page-header__text">
                {kicker ? <p className="ati-kicker">{kicker}</p> : null}
                <Heading className="ati-page-header__title">{title}</Heading>
                {description ? <p className="ati-page-header__description">{description}</p> : null}
            </div>
            {actions ? <div className="ati-page-header__actions">{actions}</div> : null}
        </header>
    );
};
